<div class="login">
  <div class="content grid grid-cols-1 lg:grid-cols-2">
    <img
      class="loginImage leftPanel hidden lg:block"
      src="../../assets/images/sandiLite.png"
      alt="Sandi Lite platform illustration"
    />
    <div class="flex flex-row rightPanel">
      <div class="flex flex-col justify-center">
        <div class="flex flex-row justify-center">
          <img width="80" src="../../assets/icons/sandi-lite.svg" alt="Sandi Lite logo" />
        </div>
        <div class="flex flex-row justify-center mb-3">
          Last Mile Made Simple
        </div>
        <form [formGroup]="loginForm" (keyup.enter)="submitLogin()" novalidate>
          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input
              matInput
              formControlName="email"
              type="email"
              [errorStateMatcher]="matcher"
              autocomplete="email"
              autofocus
            />
            <mat-error *ngIf="loginForm.get('email').hasError('required')">
              Email is required
            </mat-error>
            <mat-error *ngIf="loginForm.get('email').hasError('email')">
              Please enter a valid email address
            </mat-error>
          </mat-form-field>

          <mat-form-field class="password-input" appearance="outline">
            <mat-label>Password</mat-label>
            <input
              matInput
              formControlName="password"
              type="password"
              [errorStateMatcher]="matcher"
              autocomplete="current-password"
            />
            <mat-error *ngIf="loginForm.get('password').hasError('required')">
              Password is required
            </mat-error>
          </mat-form-field>
          <div class="flex flex-row justify-end text-sm">
            <a [routerLink]="['/', 'reset-password']" [queryParams]="{ email: loginForm.get('email').value }"
              >FORGOT PASSWORD?</a
            >
          </div>
        </form>

        <div class="mt-4">
          <sa-network-active-button [active]="activeRequest$ | async">
            <button
              mat-flat-button
              color="accent"
              (click)="submitLogin()"
              [disabled]="loginForm.invalid || (activeRequest$ | async)"
            >
              <div class="w-full flex flex-row justify-start">
                <span class="px-0">LOGIN</span>
              </div>
            </button>
          </sa-network-active-button>
        </div>
        <div class="login-conditions">
          By clicking Login, you agree to our
          <a href="http://privacy.shaleapps.com" target="_blank">Terms and Conditions</a>
        </div>
      </div>
    </div>
  </div>
</div>
